import { render } from "./CosmoCustomizeApps.vue?vue&type=template&id=5b05310f&scoped=true"
import script from "./CosmoCustomizeApps.vue?vue&type=script&lang=js"
export * from "./CosmoCustomizeApps.vue?vue&type=script&lang=js"

import "./CosmoCustomizeApps.vue?vue&type=style&index=0&id=5b05310f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b05310f"]])

export default __exports__